import React from "react";
import { Container, MainContainer, ScrollWrapper } from "./index.styled";
import Map from "../FactSheetMap";
import FactSheetPublications from "../FactSheetPublications";
import FactSheetNews from "../FactSheetNews";
import FactSheetChart from "../FactSheetChart";
import FactSheetGrowthChart from "../FactSheetGrowthChart";

const FactSheetRight = ({ data }) => {
  function convertStringToObject(data) {
    if (data) {
      return data?.split(",").reduce((acc, pair) => {
        let [key, value] = pair?.split(":");
        acc[key.trim()] = parseFloat(value.trim()); // Convert value to number
        return acc;
      }, {});
    }
  }
  const chartData = convertStringToObject(data?.cbsa_cancer_incidences);
  const growthData = convertStringToObject(data?.cbsa_cancer_growth_rate);
  return (
    <MainContainer>
      <ScrollWrapper>
        <Container>
          <Map
            data={data}
            latitude={data?.latitude}
            longitude={data?.longitude}
            zoom={13}
          />
        </Container>

        <FactSheetGrowthChart cbsa={data?.cbsa} data={growthData} />
        <FactSheetChart cbsa={data?.cbsa} data={chartData} />
        {/* <FactSheetPublications />
        <FactSheetNews /> */}
      </ScrollWrapper>
    </MainContainer>
  );
};

export default FactSheetRight;
